<template>
  <div class="auth-code-resend-link">
    <a
      v-if="canSendCode"
      class="link"
      href="#"
      @click.prevent="resendCode"
    >
      Vous n'avez pas reçu le code par message ? Recevoir un nouveau code.
    </a>
    <p v-else-if="isSendingCode">
      <b>
        <FontAwesomeIcon :icon="$icons.spinner" spin />
        Demande d'envoi d'un nouveau code en cours...
      </b>
    </p>
    <p v-else-if="maxAttemptsReached">
      <b>Vous n'avez toujours pas reçu le code ? Contactez notre support technique.</b>
    </p>
  </div>
</template>

<script>
  export default {
    name: 'AuthCodeResendLink',
    props: {
      authCode: {
        type: String,
        required: false,
      },
      loginEmail: {
        type: String,
        required: false,
      },
      loginPassword: {
        type: String,
        required: false,
      },
      signupMobilePhone: {
        type: String,
        required: false,
      },
    },
    watch: {
      authCode() {
        if (this.$store.getters['authCode/canSendCode']) {
          this.$store.dispatch('authCode/restartTimer');
        }
      },
    },
    computed: {
      canSendCode() {
        return this.$store.getters['authCode/canSendCode'];
      },
      maxAttemptsReached() {
        return this.$store.getters['authCode/maxAttemptsReached'];
      },
      isSendingCode() {
        return this.$store.state.authCode.isSending;
      },
    },
    methods: {
      async resendCode() {
        try {
          if (this.loginEmail) {
            await this.$store.dispatch('authCode/sendCodeForLogin', {
              email: this.loginEmail,
              password: this.loginPassword,
            });
          } else {
            await this.$store.dispatch('authCode/sendCodeForSignup', {
              mobilePhone: this.signupMobilePhone,
            });
          }

          await this.$addSuccess('un nouveau code vous a été envoyé. Vérifiez votre téléphone.');
        } catch (e) {
          await this.$addError('Une erreur est survenue lors de l\'envoi du code, veuillez réessayer.');
          throw e;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .code-resend-link {
    font-size: 1.4rem;
    color: $fadedTextColor;
  }

  .link {
    color: $fadedTextColor;
  }
</style>
